





















































import Component from "vue-class-component";
import { BaseRootPageComponent } from "../BaseRootPageComponent";
import { updateGTMGlobalVariables } from "@/utils/gtm";

@Component
export default class About extends BaseRootPageComponent {
  buildVersion = "";
  buildRevision = "";
  buildDate? = "";

  async created() {
    this.setTitle("About");

    // updateGTMGlobalVariables(this);

    const build = this.$nativeApp.buildInfo;
    this.buildVersion = build.version;
    this.buildRevision = build.revision;
      this.buildDate = "Mar-1-2025";//build.date;
  }
}
